<template>
	<v-layout
		justify-center
		align-center
		:style="{ height: `${$vuetify.breakpoint.height - 120}px` }"
	>
		<v-flex class="text-center">
			<v-img
				src="@/assets/logo.png"
				max-width="150"
				class="mx-auto mb-5"
				transition="scale-transition"
			/>
			
			<span class="text-uppercase text-h6">Edunix transport</span>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	name: 'Home',
};
</script>
